import React from 'react';
import ListItem from 'ListItem'

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: this.props.items,
      defaultPropertyValues: [],
      currentItemProperties: [],
      propertyNames: this.props.propertyNames
    };
    this.state.propertyNames.forEach((element, index) => {
      this.state.defaultPropertyValues[index] = "";
    });
    this.state.currentItemProperties = this.state.defaultPropertyValues;

    this.removeListItem = this.removeListItem.bind(this);
    this.updateListItem = this.updateListItem.bind(this);
    this.addListItem = this.addListItem.bind(this);
    this.handleNewItemChange = this.handleNewItemChange.bind(this);
  }

  removeListItem(id) {
    $.ajax({
      type: "DELETE",
      url: this.props.url + id,
      async: false,
      success: (response) => {
        let items = [...this.state.items];
        items.splice(items.findIndex((e) => { return e.id == id }), 1);
        this.setState({ items: items })
      }
    })
  }

  addListItem(properties) {
    let additionalFields = {};
    switch(this.props.listType) {
      case "CampaignBucket":
        additionalFields.name = properties[0];
        additionalFields.filter_string = properties[1];
        break;
      case "ConversionAction":
        additionalFields.name = properties[0];
        additionalFields.conversion_id = properties[1];
        additionalFields.conversion_type = this.props.conversionType;
        break;
      default:
        // Just send all the passed in properties to the server as additional fields
        for (let i = 0; i < properties.length; i++) {
          additionalFields['additional_field_' + i] = properties[i];
        }
    }

    $.ajax({
      type: "POST",
      url: this.props.url,
      async: false,
      data: {
        properties: {
          section_type: this.props.sectionType,
          section_id: this.props.sectionId,
          additional_fields: additionalFields
        }
      },
      success: (response) => {
        let items = [...this.state.items];
        items.push(response)
        this.setState({ items: items })
        this.setState({ currentItemProperties: this.state.defaultPropertyValues })
      }
    })
  }

  updateListItem(id, properties) {
    let additionalFields = {};
    switch(this.props.listType) {
      case "CampaignBucket":
        additionalFields.name = properties[0];
        additionalFields.filter_string = properties[1];
        break;
      case "ConversionAction":
        additionalFields.name = properties[0];
        additionalFields.conversion_id = properties[1];
        additionalFields.conversion_type = this.props.conversionType;
        break;
      default:
        // Just send all the passed in properties to the server as additional fields
        for (let i = 0; i < properties.length; i++) {
          additionalFields['additional_field_' + i] = properties[i];
        }
    }

    $.ajax({
      type: "PATCH",
      url: this.props.url + id,
      async: false,
      data: {
        properties: {
          section_type: this.props.sectionType,
          section_id: this.props.sectionId,
          additional_fields: additionalFields
        }
      }
    })
  }

  handleNewItemChange(event) {
    let properties = [];
    let inputs = event.target.parentElement.children
    for (let i = 0; i < inputs.length; i++) {
      let input = inputs[i];
      if (input.tagName == "INPUT") {
        properties.push(input.value);
      }
    }

    this.setState({
      currentItemProperties: properties
    });
  }

  render() {
    const newItemRow = this.state.currentItemProperties.map((property, index) => {
      return (
        <input key={index} className="m-1" type="string" placeholder={this.state.propertyNames[index]} value={this.state.currentItemProperties[index]} onChange={this.handleNewItemChange} />
      );
    });
    const itemList = this.state.items.map((item) => {
      return (
        <ListItem key={item.id} removeListItem={this.removeListItem} updateListItem={this.updateListItem} item={item} listType={this.props.listType} propertyNames={this.state.propertyNames} />
      );
    });
    return (
      <div>
        {newItemRow}
        <button name="button" type="button" onClick={() => this.addListItem(this.state.currentItemProperties)} style={{ background: "none" }} >
          <i className="fas fa-plus"></i>
        </button>
        <ul style={{ listStyle: "none" }}>
          {itemList}
        </ul>
      </div>
    );
  }
}

export default List;
